// mui components
import { Grid, Typography } from '@mui/material';
// components
import DialogModal from 'components/modal/dialog-modal';
import ActionButton from 'components/buttons';

const ArchiveProjectModalNewUI = ({ open, handleClose, onSubmit, StyledItemNewUI, loading }) => {
  return (
    <DialogModal
      maxWidth="455px"
      withoutPadding
      open={open}
      withCloseButton={false}
      handleClose={handleClose}
    >
      <Grid container flexDirection="column" sx={{ padding: '0px', margin: '0px' }}>
        <Grid
          container
          flexDirection="column"
          alignItems="flex-start"
          item
          xs
          sx={{ padding: '40px 40px 20px 40px', borderBottom: '1px solid #F3F4F9' }}
        >
          <Typography
            sx={{
              fontSize: '24px',
              lineHeight: '136%',
              fontWeight: 400,
              color: '#23252F',
              fontFamily: 'Inter, sans-serif !important',
            }}
          >
            Archive
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: '146%',
              fontWeight: 400,
              color: '#6E707A',
              fontFamily: 'Inter, sans-serif !important',
            }}
          >
            Are you sure you want to archive this project?
          </Typography>
        </Grid>
        <Grid sx={{ padding: '20px 40px 40px 40px' }}>
          <Typography
            sx={{
              marginBottom: '5px',
              fontSize: '14px',
              lineHeight: '146%',
              fontWeight: 400,
              color: '#6E707A',
              fontFamily: 'Inter, sans-serif !important',
            }}
          >
            You will lose the ability to:
          </Typography>
          <StyledItemNewUI text="Make updates to the calendar" />
          <StyledItemNewUI text="Receive project updates and notifications" />
          <StyledItemNewUI text="Post new updates to the activity feed" />
        </Grid>

        <Grid
          container
          justifyContent="flex-end"
          sx={{ padding: '0px 40px 20px 40px', gap: '10px' }}
        >
          <ActionButton
            label="Cancel"
            onClick={handleClose}
            disabled={loading}
            variant="secondary"
          />
          <ActionButton label="Archive Project" onClick={onSubmit} loading={loading} />
        </Grid>
      </Grid>
    </DialogModal>
  );
};

export default ArchiveProjectModalNewUI;
